import BaseComponent from "../../baseComponent.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
import styles from "../modal.scss";

export default class AppModal extends BaseComponent {
  constructor(props) {
    super(props);
    this.setDefaultOption();
    this.timer = null;
  }

  componentDidMount() {
    this.subscribe(InternalEvent.App.SHOW_APP_MODAL, (options) => this.showModal(options));
    this.$modal = $("#app-modal");
    this.$modal.modal({
        dismissible: true,
        opacity: .5,
        in_duration: 300,
        out_duration: 200,
        starting_top: "4%",
        ending_top: "10%",
        complete: () => {
          if (this.timer) {
            clearTimeout(this.timer);
          }
          this.setDefaultOption();
        }
      }
    );
  }

  componentWillUnmount() {
    this.unsubscribeAll();
  }

  setDefaultOption() {
    this.options = {
      type: "confirm",
      onCancel() {
      },
      onAgree() {
      },
      header: "",
      subHeader: ""
    }
  }

  setOptions(options) {
    this.options = {
      onCancel: typeof options.onCancel === "function" ? options.onCancel : () => {
      },
      onAgree: typeof options.onAgree === "function" ? options.onAgree : () => {
      },
      type: options.type == null ? "confirm" : options.type
    };

    $(this.refs.header).text(options.header);

    if (this.options.type === "confirm") {
      $(this.refs.cancelBtn).show();
    } else {
      $(this.refs.cancelBtn).hide();
      this.timer = setTimeout(() => {
        this.$modal.modal("close");
      }, 6000);
    }
  }

  showModal(options) {
    this.setOptions(options);
    setTimeout(() => {
      this.$modal.modal("open");
    }, 300);
  }

  handleAgree() {
    this.options.onAgree();
  }

  handleCancel() {
    this.options.onCancel();
  }

  render() {
    return (
      <div id="app-modal" className={[styles.modal, "modal"].join(' ')} style={{width: 400}}>
        <div className="modal-content">
          <h5 ref="header"/>
        </div>
        <div className={styles.footer}>
          <button className={[styles.actionButton, styles.cancelButton, "btn-flat modal-close waves-effect"].join(' ')}
                  onClick={this.handleCancel}>Cancel
          </button>
          <button className={[styles.actionButton, "btn  modal-close waves-effect"].join(' ')} onClick={this.handleAgree}>Ok</button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/app-modal/appModal.jsx